export const URGENT_PRIORITIES = ["Urgent", "Stat", "Emergent", "Urgent Immediate"];
export const ROUTINE_PRIORITIES = ["Routine", "Routine Morning", "Routine Next Business Day", "FYI"];
export const formatDuration = (seconds) => {
    const roundedSeconds = Math.round(seconds);
    if (roundedSeconds < 60) {
        return `${roundedSeconds}s`;
    }
    const minutes = Math.floor(roundedSeconds / 60);
    const remainingSeconds = roundedSeconds % 60;
    if (minutes < 60) {
        return `${minutes}m ${remainingSeconds}s`;
    }
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}h ${remainingMinutes}m ${remainingSeconds}s`;
};
export const calculateMedian = (values) => {
    if (values.length === 0)
        return 0;
    const sorted = [...values].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    if (sorted.length % 2 === 0) {
        return ((sorted[mid - 1] || 0) + (sorted[mid] || 0)) / 2;
    }
    return sorted[mid] || 0;
};
export const groupInteractionsByAccount = (interactions) => {
    return interactions.reduce((groups, interaction) => {
        var _a;
        const accountName = interaction.ToFilterObjectAccountName || "Unknown Account";
        if (!groups[accountName]) {
            groups[accountName] = [];
        }
        (_a = groups[accountName]) === null || _a === void 0 ? void 0 : _a.push(interaction);
        return groups;
    }, {});
};
export const groupInteractionsByUser = (interactions) => {
    return interactions.reduce((groups, interaction) => {
        var _a;
        const userName = interaction.ToObjectName || "Unknown User";
        if (!groups[userName]) {
            groups[userName] = [];
        }
        (_a = groups[userName]) === null || _a === void 0 ? void 0 : _a.push(interaction);
        return groups;
    }, {});
};
export const filterAccountGroups = (accountGroups, selectedAccountNames) => {
    return Object.entries(accountGroups).filter(([accountName]) => selectedAccountNames.length === 0 || selectedAccountNames.includes(accountName));
};
export const filterUserGroups = (userGroups, selectedUserNames) => {
    return Object.entries(userGroups).filter(([userName]) => selectedUserNames.length === 0 || selectedUserNames.includes(userName));
};
export const extractUrgentReadTimes = (interactions) => {
    const urgentInteractions = interactions.filter((i) => URGENT_PRIORITIES.includes(i.ToFilterPriority || ""));
    return urgentInteractions
        .map((i) => {
        if (!i.SecureMessageReadUtc || !i.SecureMessageSentUtc)
            return null;
        const sent = new Date(i.SecureMessageSentUtc);
        const read = new Date(i.SecureMessageReadUtc);
        return (read.getTime() - sent.getTime()) / 1000;
    })
        .filter((time) => time !== null && time >= 0);
};
export const extractCallbackTimes = (interactions) => {
    return interactions
        .map((i) => {
        if (!i.CallbackFromMessageIdUtc || !i.SecureMessageSentUtc)
            return null;
        const callback = new Date(i.CallbackFromMessageIdUtc);
        const sent = new Date(i.SecureMessageSentUtc);
        return (callback.getTime() - sent.getTime()) / 1000;
    })
        .filter((time) => time !== null && time >= 0);
};
export const extractCallbackDurations = (interactions) => {
    return interactions
        .map((i) => i.CallbackDurationSeconds)
        .filter((duration) => duration !== null && duration !== undefined && duration >= 0);
};
export const countUrgentInteractions = (interactions) => {
    return interactions.filter((i) => URGENT_PRIORITIES.includes(i.ToFilterPriority || "")).length;
};
export const countRoutineInteractions = (interactions) => {
    return interactions.filter((i) => ROUTINE_PRIORITIES.includes(i.ToFilterPriority || "")).length;
};
export const countVoicemailInteractions = (interactions) => {
    return interactions.filter((i) => i.InteractionFinalAction === "VoiceMessage").length;
};
export const countCallbackInteractions = (interactions) => {
    return interactions.filter((i) => i.CallbackFromMessageIdUtc).length;
};
export const countTransferInteractions = (interactions) => {
    return interactions.filter((i) => {
        const action = i.InteractionFinalAction || "";
        const normalizedAction = action.replace(/\s+/g, "");
        return (normalizedAction === "BlindTransfer" ||
            normalizedAction === "ControlledTransfer" ||
            normalizedAction === "HandoffTransfer");
    }).length;
};
export const countUniquePractices = (interactions) => {
    return new Set(interactions.map((i) => i.ToFilterObjectName)).size;
};
export const generateAggregateAccountName = (selectedUserNames, selectedAccountNames) => {
    if (selectedUserNames.length > 0 && selectedAccountNames.length > 0) {
        return "All Selected Accounts & Users";
    }
    if (selectedUserNames.length > 0) {
        return "All Selected Users";
    }
    return "All Selected Accounts";
};
export const shouldShowAggregateCard = (selectedAccountNames, selectedUserNames) => {
    return (selectedAccountNames.length > 1 ||
        selectedUserNames.length > 1 ||
        (selectedAccountNames.length > 0 && selectedUserNames.length > 0));
};
//# sourceMappingURL=executiveSummaryUtils.js.map